import { Editor, Range } from 'vendor/slate'

export const getSelectionPlainText = (editor, selection = editor.selection) => {
  if (!selection) return ''

  return Editor.string(editor, selection)
}

export const getSelectionFragmentMarkdown = (editor, selection = editor.selection) => {
  if (!selection) return ''

  const fragment = Editor.fragment(editor, selection)
  return fragment
    .map(block => {
      if (!block.children) return ''
      return block.children.map(child => child.text || '').join('')
    })
    .join('\n\n')
}

export const hasExpandedSelection = (editor) => {
  const { selection } = editor
  return !!selection && !Range.isCollapsed(selection)
}
